enum Path {
  ROOT = '/',
  LOGIN = '/login',
  REGISTRATION = '/registration',

  SALES_BIDS = '/sales/bids',
  SALES_BIDS_SUMMARY = '/sales/bids/summary/active',
  SALES_BIDS_REGISTER = '/sales/bids/register',
  SALES_BIDS_DECISION = '/sales/bids/decision',
  SALES_BIDS_DECISION_DIRECTOR_APPROVAL = '/sales/bids/decision/director/approval',
  SALES_BIDS_SPEC = '/sales/bids/spec',
  SALES_BIDS_PAPERWORK = '/sales/bids/paperwork',
  SALES_BIDS_COST = '/sales/bids/cost',
  SALES_BIDS_EQUIPMENT = '/sales/bids/equipments',

  SALES_NO_BIDS_SUMMARY = '/sales/bids/summary/inactive',
  SALES_NO_BIDS_SPEC = '/sales/bids/inactive/spec',
  SALES_NO_BIDS_EQUIPMENT = '/sales/bids/inactive/equipments',
  SALES_NO_BIDS_PAPERWORK = '/sales/bids/inactive/paperwork',

  PROJECTS = '/projects',
  PROJECTS_SUMMARY = '/projects/summary',
  PROJECTS_COMPLETED = '/projects/completed',
  PROJECTS_CANCELLED = '/projects/cancelled',
  PROJECTS_OVERVIEW = '/projects/overview',
  PROJECTS_CANCELLED_OVERVIEW = '/projects/cancelled/overview',
  PROJECTS_COST = '/projects/cost',
  PROJECTS_SPEC = '/projects/spec',
  PROJECTS_PAPERWORK = '/projects/paperwork',
  PROJECTS_EQUIPMENT = '/project/spec/equipments',

  FINANCES = '/finances',
  FINANCES_SUMMARY = '/finances/summary',
  FINANCES_PROJECTS_UNALLOCATED = '/finances/projects/unallocated',
  FINANCES_PROJECTS_UNALLOCATED_OVERVIEW = '/finances/projects/unallocated/overview',

  SITES = '/sites',
  TIMESHEETS = '/timesheets',
  TIMESHEETS_ENTRY = '/timesheets/entry',
  TIMESHEETS_SUMMARY = '/timesheets/summary',
  TIMESHEETS_APPROVAL = '/timesheets/approval',
  TRAININGS = '/trainings',
  DOCUMENTS = '/documents',

  ADJUSTMENT = '/adjustment',
  ADJUSTMENT_PERMISSION = '/adjustment/permission',
  ADJUSTMENT_ROLE = '/adjustment/role',
  ADJUSTMENT_MONDAY = '/adjustment/monday',
}

export default Path
